import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Beneficiary } from "src/app/ui/models/domains/pbm/Beneficiary/beneficiary";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";

@Component({
  templateUrl: "./vinculated-socialnumber-dialog.component.html",
  styleUrls: ["./vinculated-socialnumber-dialog.component.scss"],
})
export class VinculatedSocialnumberDialogComponent {
  beneficiary: Beneficiary;
  companies: Company[] = [];

  constructor(
    private dialogRef: MatDialogRef<VinculatedSocialnumberDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data && data.beneficiary) {
      this.beneficiary = data.beneficiary;
      this.companies = data.beneficiary.getCompany();
    }
  }

  hasCompany(): boolean {
    return this.companies.length > 0;
  }

  close() {
    this.dialogRef.close(true);
  }
}
